module.exports = ".row{\r\n    padding:20px 0px 10px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}\r\n\r\nlabel{\r\n    word-wrap: break-word;\r\n    display: block;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/telecaller/telecaller-form/telecaller-form.component.css
// module id = ./src/app/prospect/telecaller/telecaller-form/telecaller-form.component.css
// module chunks = main